import { render } from "./FolderGradeList.vue?vue&type=template&id=470a9ccd"
import script from "./FolderGradeList.vue?vue&type=script&lang=js"
export * from "./FolderGradeList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__